export default {
	title: 'timer',
	icon: 'far fa-clock',
	components: [{ title: 'auto', component: 'auto' }],
};
